<section class="my-account">
  <h1 class="reservation-details">
    MY ACCOUNT
  </h1>
  <section class="row acc-numb acc-height">
    <section class="col-xs-8 col-sm-8 col-md-8 acc-title">
      @if (baseSiteId) {
        <img [src]="'/../../../assets/icons/'+baseSiteId+'/user-account.svg'" alt="Account">
      }
      <span class="acc-pos">Account&nbsp;{{accntId}}</span>
    </section>
    <section class="col-xs-4 col-sm-4 col-md-4 acc-title-manage">
      <a (click)="navigateToAccountTab()">
        @if (baseSiteId) {
          <img [src]="'/../../../assets/icons/'+baseSiteId+'/edit.svg'" alt="Edit">
        }
        Manage </a>
    </section>
  </section>
  <hr>
</section>
<section class="section-one">
  <section id="filter-by">
    <ul>
      <li class="myacc_representatives">
        <div class="" *ngIf="customerRepDetails != undefined && customerRepDetails.length > 0">
          <section class="sec-rep" *ngFor="let acc of customerRepDetails;let in = index">
            <div class="img-container">
              <img [src]="getImage(acc)" alt="Sales Rep" *ngIf="acc?.profilePic">
              <img src="/../../../assets/img/AccProfile.png" alt="Representative Image" *ngIf="!acc?.profilePic">
            </div>
            <div class="txt-container">
              <h4 style="text-transform: capitalize" *ngIf="acc?.repName.length != 0">{{acc?.repName}}</h4>
              <p style="text-transform: capitalize" *ngIf="acc?.repDescription.length != 0">{{acc?.repDescription}}
              </p>
              <div class="email" *ngIf="acc?.repFax?.length != 0">
                <span>Fax: {{acc?.repFax}}</span>
              </div>
              <div class="email" *ngIf="acc?.repEmail?.length != 0">
                <a href="{{'mailto:'+acc?.repEmail}}"><img src="/../../../assets/icons/mail.svg"
                    alt="Mail">{{acc?.repEmail}}</a>
              </div>
              <div class="phone" *ngIf="acc?.repPhone.length != 0">
                <span>
                  <a href="javascript:void(0)">
                    <img src="/../../../assets/icons/phone.svg" alt="Phone">
                    {{formatPhoneNumber(acc?.repPhone)}}
                  </a></span>
              </div>
            </div>
            <hr>
          </section>
        </div>
        <div class="d-flex need-assistance">
          <div class="content">
            <h4 *ngIf="customerRepDetails != undefined && customerRepDetails.length > 0 && baseSiteId == 'vsh'">Need
              assistance?</h4>
            <div *ngIf="!customerRepDetails || customerRepDetails.length == 0">
              <app-need-assistance></app-need-assistance>
            </div>
            <div class="request-support" *ngIf="baseSiteId == 'vsh'">
              <a id="customerReqSupportFooter" (click)="openModal()">
                <img [src]="'/../../../assets/icons/'+baseSiteId+'/request-support.png'" alt="">
                Request support</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </section>
</section>